import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { RootState } from './store/types';

import AppLayout from './layouts/AppLayout';

// BrowserRouter   HashRouter

// import Login from './pages/login/Login';
import './App.css';
import ResetPassword from './pages/resetPassword/ResetPassword';
import ResetPasswordConfirm from './pages/resetPassword/ResetPasswordConfirm';
import * as actions from './store/actions/auth';
import './style.css';

import Company from './features/manage/company/Company';
import ApprovalRoutes from './features/approval/ApprovalRoutes';
import Invoices from './features/manage/company/Invoices';

import Dashboard from './pages/dashboard/Dashboard';
import Biblio from './features/database/biblio/Biblio';
import Manufacturer from './features/database/manufacturer/Manufacturer';
import Consultant from './features/database/consultant/Consultant';
import Classification from './features/database/classification/Classification';
import ProfessionBond from './features/database/professionBond/ProfessionBond';
import Properties from './features/database/properties/Properties';
import PropertySet from './features/database/propertySet/PropertySet';
import Solution from './features/database/solution/Solution';
import Product from './features/database/product/Product';
import TechnicalReportItem from './features/database/technicalReportItem/TechnicalReportItem';
import TechnicalReportItemSet from './features/database/technicalReportItemSet/TechnicalReportItemSet';
import TypeMarkTemplate from './features/database/templates/TypemarkTemplate';
import Units from './features/database/units/Units';
import Documentation from './features/documentation/DocumentationV2';
import CreateCompany from './features/manage/company/CreateCompany';
import RightsController from './features/manage/rights/RightsController';
import TeamsController from './features/manage/teams/TeamsController';
import ConfirmUser from './features/manage/users/components/ConfirmUser';
import PdfPrint from './pages/pdfPrint/PdfPrint';
import Phase from './features/phase/Phase';
import PhaseForRevit from './features/phase/PhaseForRevit';
import Print from './pages/print/Print';
import Building from './features/project/building/Building';
import BuildingObject from './features/project/buildingObject/BuildingObject';
import BuildingModel from './features/project/buldingModel/BuildingModel';
import AppearancesPage from './features/project/appearances/AppearancesPage';
import Project from './features/project/project/Project';
import ProjectInformation from './features/project/projectInformation/ProjectInformation';
import TypeMark from './features/project/typemark/TypeMark';
import Confirm from './pages/registration/Confirm';
import history from './history';
import SuccessFulRegistration from './pages/registration/SuccessfulRegistration';
import InstructionsTemplates from './features/instructions/InstructionsTemplate';
import Users from './features/manage/users/Users';
import RevitAddingPage from './pages/revitAdding/RevitAddingPage';
import Compose from './features/project/compose/Compose';
import Login from './pages/login/Login';

const pathsForTypeMarks = [
  'vyrobky/nabytek',
  'vyrobky/doplnky',
  'vyrobky/prvky-orientacniho-systemu',
  'vyrobky/technologicka-zarizeni-soubory',
  'vyrobky/dvere-vrata',
  'vyrobky/okna',
  'vyrobky/tesarske-konstrukce',
  'vyrobky/vyrobky-truhlarske',
  'vyrobky/vyrobky-zamecnicke',
  'vyrobky/vyrobky-klempirske',
  'vyrobky/vyrobky-ostatni',
  'prvky/zemni-prace',
  'prvky/zakladove-konstrukce',
  'prvky/operne-zarubni-steny',
  'prvky/nosne-konstrukce-svisle-vodorovne',
  'prvky/konstrukce-spojujici-ruzne-urovne',
  'prvky/steny',
  'prvky/lehke-obvodove-plaste',
  'prvky/proskelene-mobilni-pricky',
  'prvky/strechy',
  'prvky/podlahy',
  'prvky/podhledy',
  'skladby/podlahy',
  'skladby/steny',
  'skladby/strechy',
  'skladby/podhledy',
  'skladby/obklady',
];

class Routes extends Component<RoutesProps> {
  componentDidMount() {
    this.props.onTryAutoSignup();
  }

  render() {
    return (
      <>
        <Router history={history}>
          <div>
            <Switch>
              <Route
                path="/app"
                render={(props) =>
                  this.props.isAuthenticated === true ? (
                    <AppLayout {...props}>
                      <Route exact path="/app" render={() => <Redirect to="/app/dashboard" />} />
                      <Route exact path="/app/dashboard" render={() => <Dashboard />} />

                      <Route
                        exact
                        path="/app/nastaveni/ke-stazeni/revit-addin"
                        render={() => <RevitAddingPage />}
                      />

                      <Route
                        path="/app/sprava"
                        render={() => <Dashboard>sprava dashboard</Dashboard>}
                      />
                      <Route
                        path="/app/nastaveni/sprava-firmy/zalozit-firmu"
                        render={(props) => <CreateCompany history={props.history} />}
                      />
                      <Route
                        path="/app/nastaveni/sprava-firmy/sprava-firmy"
                        render={() => <Company />}
                      />
                      <Route
                        path="/app/nastaveni/sprava-firmy/faktury"
                        render={() => <Invoices />}
                      />
                      <Route
                        path="/app/nastaveni/sprava-firmy/sprava-tymu"
                        render={(props) => <TeamsController history={props.history} />}
                      />
                      <Route
                        path="/app/nastaveni/sprava-firmy/sprava-roli"
                        render={(props) => <RightsController history={props.history} />}
                      />
                      <Route
                        path="/app/nastaveni/sprava-firmy/sprava-uzivatelu/:id?"
                        render={() => <Users />}
                      />
                      <ApprovalRoutes />
                      <Route
                        path="/app/nastaveni/super-admin/databaze/jednotky"
                        render={() => <Units />}
                      />
                      <Route
                        path="/app/nastaveni/super-admin/databaze/tridnik"
                        render={() => <Classification />}
                      />
                      <Route path="/app/data/stavby/stavby" render={() => <Building />} />
                      <Route path="/app/data/akce/sprava-akci" render={() => <Project />} />
                      <Route path="/app/akce/sprava/model" render={() => <BuildingModel />} />
                      <Route path="/app/akce/sprava/faze/vykonove-faze" render={() => <Phase />} />
                      <Route path="/app/akce/sprava/vzhledy" render={() => <AppearancesPage />} />
                      <Route path="/app/data/reseni/vlastnosti" render={() => <Properties />} />
                      <Route
                        path="/app/data/reseni/sady-vlastnosti"
                        render={() => <PropertySet />}
                      />
                      <Route path="/app/data/obecne/biblio" render={() => <Biblio />} />
                      <Route
                        path="/app/data/reseni/polozky-zpravy"
                        render={() => <TechnicalReportItem />}
                      />

                      <Route path="/app/data/obecne/vyrobce" render={() => <Manufacturer />} />
                      <Route path="/app/data/obecne/konzultant" render={() => <Consultant />} />
                      <Route
                        path="/app/data/reseni/sady-zprav"
                        render={() => <TechnicalReportItemSet />}
                      />
                      <Route
                        path="/app/data/reseni/profesni-vazby"
                        render={() => <ProfessionBond />}
                      />
                      <Route path="/app/data/reseni/reseni/:id?" render={() => <Solution />} />
                      <Route
                        path="/app/data/reseni/dezeny/:id?"
                        render={({ match }) => (
                          <Redirect
                            to={`/app/data/reseni/reseni${
                              match.params.id ? `/${match.params.id}` : ''
                            }`}
                          />
                        )}
                      />
                      <Route
                        path="/app/data/reseni/upravy-povrchu/:id?"
                        render={({ match }) => (
                          <Redirect
                            to={`/app/data/reseni/reseni${
                              match.params.id ? `/${match.params.id}` : ''
                            }`}
                          />
                        )}
                      />
                      <Route path="/app/data/reseni/vyrobky/:id?" render={() => <Product />} />
                      <Route
                        path={`/app/akce/(${pathsForTypeMarks.join('|')})/sestavy/:id?`}
                        render={(props) => <TypeMark match={props.match} isRevitView={false} />}
                      />
                      <Route
                        path={`/app/akce/(${pathsForTypeMarks.join('|')})/tisk`}
                        render={() => <Print />}
                      />
                      <Route
                        path={`/app/akce/(${pathsForTypeMarks.join('|')})/spolecne-informace`}
                        render={() => <ProjectInformation />}
                      />
                      <Route
                        path="/app/akce/stavba/stavebni-objekty"
                        render={() => <BuildingObject />}
                      />
                      <Route
                        path="/app/data/sablony/type-mark"
                        render={() => <TypeMarkTemplate />}
                      />
                      <Route
                        path="/app/data/sablony/instrukce/:id?"
                        render={() => <InstructionsTemplates />}
                      />
                      {/* <Route
                        path="/app/akce/vyrobky/dvere-vrata/tisk"
                        render={() => <Print />}
                      /> */}
                      <Route exact path="/app/pdf-tisk" render={() => <PdfPrint />} />
                      <Route path="/app/akce/sprava/dokumentace" render={() => <Documentation />} />
                    </AppLayout>
                  ) : (
                    <Redirect to="/login" />
                  )
                }
              />
              <Route
                path={`/dvere-vrata/sestavy/:id`}
                render={(props) => {
                  return this.props.isAuthenticated === true ? (
                    <TypeMark match={props.match} isRevitView />
                  ) : (
                    <Redirect to="/login" />
                  );
                }}
              />
              <Route
                path={`/vykonove-faze/:id?`}
                render={(props) => {
                  return this.props.isAuthenticated === true ? (
                    <PhaseForRevit match={props.match} />
                  ) : (
                    <Redirect to="/login" />
                  );
                }}
              />
              <Route path="/reset-password" render={() => <ResetPassword />} />
              <Route
                path="/password-reset-confirm/:token"
                render={() => <ResetPasswordConfirm />}
              />
              <Route
                exact
                path="/registration-confirm/:token"
                render={(props) => <Confirm {...(props as any)} />}
              />
              <Route
                exact
                path="/employee-verify/:token"
                render={(props) => <ConfirmUser {...(props as any)} />}
              />

              <Route exact path="/test" render={() => <Compose />} />

              <Route exact path="/login" render={() => <Login />} />

              <Route exact path="/registration" render={() => <SuccessFulRegistration />} />
              {/* <Route exact path="/app/databaze/obecne/jednotky" component={ResetPassword} />     */}
              {/* <Route exact path="/three" render={() => <ThreeTesting />} /> */}
              <Redirect to="/app" />
            </Switch>
          </div>
        </Router>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  isAuthenticated: state.auth.isLoggedIn,
});

const mapDispatchToProps = (dispatch: any) => ({
  onTryAutoSignup: () => dispatch(actions.authCheckState()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface RoutesOwnProps {
  history?: any;
}

type RoutesProps = PropsFromRedux & RoutesOwnProps;

export default connector(Routes);
